import 'maplibre-gl/dist/maplibre-gl.css';
import { bootstrap } from './app/bootstrap.js';

bootstrap();
